module.exports = __webpack_public_path__ + "img/coupon-item-invalid-bg.648fa679.png";